import {OfferType} from "../../../../../../../api/generated";
import {SelectOption} from "../../../../../../elements/select/SelectDropdown";

export const allOfferTypeOptions: SelectOption<OfferType>[] = [
    {
        value: OfferType.NewVehicle,
        label: "New"
    },
    {
        value: OfferType.Service,
        label: "Service"
    },
    {
        value: OfferType.UsedVehicle,
        label: "Used"
    }
]

export const getOfferTypeName = (offerType: OfferType) => {
    const option = allOfferTypeOptions.filter(o => o.value === offerType)

    if (option && option.length === 1) {
        return option[0].label
    }

    throw new Error(`Unable to handle offerType: ${offerType} correctly`)
}
